(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6366],{

/***/ 90401:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app",
      function () {
        return __webpack_require__(21838);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* reexport */ DownloadApps_bs_make; }
});

// EXTERNAL MODULE: ./src/common/util.bs.js
var util_bs = __webpack_require__(7667);
// EXTERNAL MODULE: ./src/bindings/BsCss.bs.js + 1 modules
var BsCss_bs = __webpack_require__(71863);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./src/components/StaticImage.bs.js
var StaticImage_bs = __webpack_require__(30369);
// EXTERNAL MODULE: ./src/components/library/DownloadAppleApp.bs.js
var DownloadAppleApp_bs = __webpack_require__(75897);
// EXTERNAL MODULE: ./src/components/library/DownloadGoogleApp.bs.js
var DownloadGoogleApp_bs = __webpack_require__(59195);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/apps/AppsHeaderSection.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE







var container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* backgroundImage */.NxW({
        NAME: "url",
        VAL: "/images/downloadApps/downloadTheApp_backgroud.png"
    }),
    tl: {
        hd: BsCss_bs/* backgroundRepeat */.FDc("noRepeat"),
        tl: {
            hd: BsCss_bs/* backgroundPosition */.k0m("top"),
            tl: {
                hd: BsCss_bs/* backgroundSize */.G4q("cover"),
                tl: {
                    hd: BsCss_bs/* position */.FKU("relative"),
                    tl: {
                        hd: BsCss_bs/* backgroundSize */.G4q({
                            NAME: "size",
                            VAL: [
                                BsCss_bs/* pct */.hdZ(100),
                                BsCss_bs/* pct */.hdZ(45)
                            ]
                        }),
                        tl: {
                            hd: BsCss_bs/* media */.BC2("(min-width: 768px) and (max-width: 1023px)", {
                                hd: BsCss_bs/* backgroundSize */.G4q({
                                    NAME: "size",
                                    VAL: [
                                        BsCss_bs/* pct */.hdZ(100),
                                        BsCss_bs/* pct */.hdZ(55)
                                    ]
                                }),
                                tl: /* [] */ 0
                            }),
                            tl: {
                                hd: BsCss_bs/* media */.BC2("(min-width: 1024px)", {
                                    hd: BsCss_bs/* backgroundSize */.G4q({
                                        NAME: "size",
                                        VAL: [
                                            BsCss_bs/* pct */.hdZ(100),
                                            BsCss_bs/* pct */.hdZ(70)
                                        ]
                                    }),
                                    tl: /* [] */ 0
                                }),
                                tl: /* [] */ 0
                            }
                        }
                    }
                }
            }
        }
    }
});
var innerContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(40)),
    tl: {
        hd: BsCss_bs/* media */.BC2("(min-width: 768px) and (max-width: 1023px)", {
            hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(89)),
            tl: /* [] */ 0
        }),
        tl: {
            hd: BsCss_bs/* media */.BC2("(min-width: 1024px)", {
                hd: BsCss_bs/* display */.jfB("flex"),
                tl: {
                    hd: BsCss_bs/* justifyItems */.eYb("center"),
                    tl: {
                        hd: BsCss_bs/* justifyContent */.KlP("center"),
                        tl: {
                            hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(39)),
                            tl: /* [] */ 0
                        }
                    }
                }
            }),
            tl: /* [] */ 0
        }
    }
});
var leftContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* flex */.fUN({
        NAME: "num",
        VAL: 1.0
    }),
    tl: {
        hd: BsCss_bs/* marginTop */.E9m("auto"),
        tl: {
            hd: BsCss_bs/* marginBottom */.yl7("auto"),
            tl: /* [] */ 0
        }
    }
});
var rightContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* flex */.fUN({
        NAME: "num",
        VAL: 1.0
    }),
    tl: {
        hd: BsCss_bs/* display */.jfB("flex"),
        tl: {
            hd: BsCss_bs/* flexDirection */.Me8("column"),
            tl: {
                hd: BsCss_bs/* justifyContent */.KlP("spaceEvenly"),
                tl: /* [] */ 0
            }
        }
    }
});
var mobileTextContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* textAlign */.ydu("center"),
    tl: {
        hd: BsCss_bs/* media */.BC2("(min-width: 1024px)", {
            hd: BsCss_bs/* display */.jfB("none"),
            tl: /* [] */ 0
        }),
        tl: /* [] */ 0
    }
});
var desktopTextContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("none"),
    tl: {
        hd: BsCss_bs/* media */.BC2("(min-width: 1024px)", {
            hd: BsCss_bs/* display */.jfB("block"),
            tl: /* [] */ 0
        }),
        tl: /* [] */ 0
    }
});
var headerText = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* position */.FKU("relative"),
    tl: {
        hd: BsCss_bs/* color */.$_Y(BsCss_bs/* hex */.$v1("FFFFFF")),
        tl: {
            hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(32)),
            tl: {
                hd: BsCss_bs/* fontWeight */.Ue2({
                    NAME: "num",
                    VAL: 600
                }),
                tl: {
                    hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(40)),
                    tl: {
                        hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs.px(16)),
                        tl: {
                            hd: BsCss_bs/* media */.BC2("(min-width: 768px) and (max-width: 1023px)", {
                                hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs.px(16)),
                                tl: /* [] */ 0
                            }),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }
    }
});
var contentText = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* position */.FKU("relative"),
    tl: {
        hd: BsCss_bs/* color */.$_Y(BsCss_bs/* hex */.$v1("FFFFFF")),
        tl: {
            hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(16)),
            tl: {
                hd: BsCss_bs/* fontWeight */.Ue2({
                    NAME: "num",
                    VAL: 400
                }),
                tl: {
                    hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(22)),
                    tl: {
                        hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs.px(38)),
                        tl: {
                            hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(70.0)),
                            tl: {
                                hd: BsCss_bs/* marginLeft */.oIA("auto"),
                                tl: {
                                    hd: BsCss_bs/* marginRight */.wzR("auto"),
                                    tl: {
                                        hd: BsCss_bs/* media */.BC2("(min-width: 768px) and (max-width: 1023px)", {
                                            hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(50.0)),
                                            tl: /* [] */ 0
                                        }),
                                        tl: {
                                            hd: BsCss_bs/* media */.BC2("(min-width: 1024px)", {
                                                hd: BsCss_bs/* marginLeft */.oIA("zero"),
                                                tl: {
                                                    hd: BsCss_bs/* marginRight */.wzR("zero"),
                                                    tl: /* [] */ 0
                                                }
                                            }),
                                            tl: /* [] */ 0
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
});
var img = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(80)),
    tl: {
        hd: BsCss_bs/* marginLeft */.oIA("auto"),
        tl: {
            hd: BsCss_bs/* marginRight */.wzR("auto"),
            tl: {
                hd: BsCss_bs/* media */.BC2("(min-width: 768px) and (max-width: 1023px)", {
                    hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(60.0)),
                    tl: /* [] */ 0
                }),
                tl: {
                    hd: BsCss_bs/* media */.BC2("(min-width: 1024px)", {
                        hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(70)),
                        tl: /* [] */ 0
                    }),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var subTitleText = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* position */.FKU("relative"),
    tl: {
        hd: BsCss_bs/* color */.$_Y(BsCss_bs/* hex */.$v1("000")),
        tl: {
            hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(32)),
            tl: {
                hd: BsCss_bs/* fontWeight */.Ue2({
                    NAME: "num",
                    VAL: 600
                }),
                tl: {
                    hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(40)),
                    tl: {
                        hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs.px(24)),
                        tl: {
                            hd: BsCss_bs/* textAlign */.ydu("center"),
                            tl: {
                                hd: BsCss_bs/* media */.BC2("(min-width: 1024px)", {
                                    hd: BsCss_bs/* textAlign */.ydu("left"),
                                    tl: /* [] */ 0
                                }),
                                tl: /* [] */ 0
                            }
                        }
                    }
                }
            }
        }
    }
});
var appsDiv = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(50)),
    tl: {
        hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(50)),
        tl: {
            hd: BsCss_bs/* media */.BC2("(min-width: 1024px)", {
                hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(100)),
                tl: /* [] */ 0
            }),
            tl: /* [] */ 0
        }
    }
});
var appsInnerDiv = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("flex"),
    tl: {
        hd: BsCss_bs/* justifyContent */.KlP("center"),
        tl: {
            hd: BsCss_bs/* media */.BC2("(min-width: 1024px)", {
                hd: BsCss_bs/* justifyContent */.KlP("flexStart"),
                tl: /* [] */ 0
            }),
            tl: /* [] */ 0
        }
    }
});
var appsLogo = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs.px(158)),
    tl: {
        hd: BsCss_bs/* marginRight */.wzR(BsCss_bs.px(20)),
        tl: /* [] */ 0
    }
});
var Styles = {
    container: container,
    innerContainer: innerContainer,
    leftContainer: leftContainer,
    rightContainer: rightContainer,
    mobileTextContainer: mobileTextContainer,
    desktopTextContainer: desktopTextContainer,
    headerText: headerText,
    contentText: contentText,
    img: img,
    subTitleText: subTitleText,
    appsDiv: appsDiv,
    appsInnerDiv: appsInnerDiv,
    appsLogo: appsLogo
};
function AppsHeaderSection(props) {
    var match = util_bs/* EnvUtil.currentCountry */.i3.currentCountry;
    var tmp;
    if (match.TAG === /* Ok */ 0) {
        switch(match._0){
            case /* GreatBritain */ 1:
                tmp = "/images/downloadApps/downloadTheApp_HeaderPhone_UK.png";
                break;
            case /* UnitedStates */ 2:
                tmp = "/images/downloadApps/downloadTheApp_HeaderPhone_US.png";
                break;
            case /* NewZealand */ 3:
                tmp = "/images/downloadApps/downloadTheApp_HeaderPhone_NZ.png";
                break;
            case /* Australia */ 0:
            case /* Canada */ 4:
                tmp = "/images/downloadApps/downloadTheApp_HeaderPhone.png";
                break;
        }
    } else {
        tmp = "/images/downloadApps/downloadTheApp_HeaderPhone.png";
    }
    return jsx_runtime.jsx("div", {
        children: jsx_runtime.jsxs("div", {
            children: [
                jsx_runtime.jsxs("div", {
                    children: [
                        jsx_runtime.jsxs("div", {
                            children: [
                                jsx_runtime.jsx("h1", {
                                    children: util_bs/* ReactStuff.s */.p_.s("Never lose a gift card again! "),
                                    className: headerText
                                }),
                                jsx_runtime.jsx("h3", {
                                    children: util_bs/* ReactStuff.s */.p_.s("Store eGift cards in your Prezzee Wallet on the free Prezzee App!"),
                                    className: contentText
                                })
                            ],
                            className: mobileTextContainer
                        }),
                        jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                            src: tmp,
                            alt: "Prezzee download apps header image",
                            width: 667,
                            height: 733,
                            className: img
                        })
                    ],
                    className: leftContainer
                }),
                jsx_runtime.jsxs("div", {
                    children: [
                        jsx_runtime.jsxs("div", {
                            children: [
                                jsx_runtime.jsx("h1", {
                                    children: util_bs/* ReactStuff.s */.p_.s("Never lose a gift card again! "),
                                    className: headerText
                                }),
                                jsx_runtime.jsx("h3", {
                                    children: util_bs/* ReactStuff.s */.p_.s("Store eGift cards in your Prezzee Wallet on the free Prezzee App!"),
                                    className: contentText
                                })
                            ],
                            className: desktopTextContainer
                        }),
                        jsx_runtime.jsxs("div", {
                            children: [
                                jsx_runtime.jsx("h2", {
                                    children: util_bs/* ReactStuff.s */.p_.s("Download now!"),
                                    className: subTitleText
                                }),
                                jsx_runtime.jsxs("div", {
                                    children: [
                                        jsx_runtime.jsx(DownloadAppleApp_bs/* make */.S, {
                                            className: appsLogo
                                        }),
                                        jsx_runtime.jsx(DownloadGoogleApp_bs/* make */.S, {
                                            className: appsLogo
                                        })
                                    ],
                                    className: appsInnerDiv
                                })
                            ],
                            className: appsDiv
                        })
                    ],
                    className: rightContainer
                })
            ],
            className: innerContainer
        }),
        className: container
    });
}
var make = AppsHeaderSection;
var $$default = (/* unused pure expression or super */ null && (AppsHeaderSection));
 /* container Not a pure module */ 

// EXTERNAL MODULE: ./src/css/Theme.bs.js
var Theme_bs = __webpack_require__(93802);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_dict.js
var js_dict = __webpack_require__(43437);
// EXTERNAL MODULE: ./node_modules/bs-css/src/Css_Legacy_Core.bs.js
var Css_Legacy_Core_bs = __webpack_require__(68364);
;// CONCATENATED MODULE: ./src/components/pages/apps/ReviewCard.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE







var ReviewCard_bs_container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* backgroundImage */.NxW({
        NAME: "url",
        VAL: "/images/downloadApps/quote_bg.svg"
    }),
    tl: {
        hd: BsCss_bs/* backgroundRepeat */.FDc("noRepeat"),
        tl: {
            hd: BsCss_bs/* backgroundSize */.G4q("auto"),
            tl: {
                hd: BsCss_bs/* position */.FKU("relative"),
                tl: {
                    hd: BsCss_bs/* width */.bf$(BsCss_bs.px(288)),
                    tl: {
                        hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(298)),
                        tl: {
                            hd: BsCss_bs/* borderRadius */.E0l(BsCss_bs.px(8)),
                            tl: {
                                hd: BsCss_bs/* boxShadow */.Wnp(Css_Legacy_Core_bs/* Shadow.box */.jXB.box(BsCss_bs.px(4), BsCss_bs.px(4), BsCss_bs.px(25), undefined, undefined, BsCss_bs/* rgba */.m4f(68, 68, 68, BsCss_bs/* pct */.hdZ(15.0)))),
                                tl: {
                                    hd: BsCss_bs/* backgroundColor */.Czw(Theme_bs/* Color.white */.Il.white),
                                    tl: {
                                        hd: BsCss_bs/* padding */.o3D(BsCss_bs.px(20)),
                                        tl: /* [] */ 0
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
});
var titleText = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* position */.FKU("relative"),
    tl: {
        hd: BsCss_bs/* color */.$_Y(BsCss_bs/* hex */.$v1("444")),
        tl: {
            hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(18)),
            tl: {
                hd: BsCss_bs/* fontWeight */.Ue2({
                    NAME: "num",
                    VAL: 500
                }),
                tl: {
                    hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(25)),
                    tl: {
                        hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(12)),
                        tl: {
                            hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs.px(12)),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }
    }
});
var bodyText = curry._1(BsCss_bs/* style */.oBv, {
    hd: Theme_bs/* Typography.defaultFonts */.ZT.defaultFonts,
    tl: {
        hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(16)),
        tl: {
            hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(24)),
            tl: {
                hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.midGrey */.Il.midGrey),
                tl: {
                    hd: BsCss_bs/* fontWeight */.Ue2("normal"),
                    tl: {
                        hd: BsCss_bs/* fontStyle */.p_N("normal"),
                        tl: /* [] */ 0
                    }
                }
            }
        }
    }
});
var ReviewCard_bs_img = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs.px(87)),
    tl: /* [] */ 0
});
var ReviewCard_bs_Styles = {
    container: ReviewCard_bs_container,
    titleText: titleText,
    bodyText: bodyText,
    img: ReviewCard_bs_img
};
function ReviewCard(props) {
    return jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                src: "/images/downloadApps/review_stars.svg",
                alt: "review stars",
                width: 87,
                height: 20,
                className: ReviewCard_bs_img
            }),
            jsx_runtime.jsx("h3", {
                children: util_bs/* ReactStuff.s */.p_.s(props.titleText),
                className: titleText
            }),
            jsx_runtime.jsx("h4", {
                children: util_bs/* ReactStuff.s */.p_.s(props.bodyText),
                className: bodyText
            })
        ]
    });
}
var ReviewCard_bs_make = ReviewCard;
 /* container Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_option.js
var caml_option = __webpack_require__(25400);
// EXTERNAL MODULE: ./node_modules/swiper/swiper-react.mjs + 2 modules
var swiper_react = __webpack_require__(48929);
;// CONCATENATED MODULE: ./src/components/pages/apps/AppsReviewSection.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE










var swiperBreakpoints = js_dict/* fromList */.hy({
    hd: [
        "0",
        {
            slidesPerView: 1.1,
            spaceBetween: 22,
            slidesPerGroup: 1
        }
    ],
    tl: {
        hd: [
            "320",
            {
                slidesPerView: 1.2,
                spaceBetween: 22,
                slidesPerGroup: 1
            }
        ],
        tl: {
            hd: [
                "400",
                {
                    slidesPerView: 1.2,
                    spaceBetween: 22,
                    slidesPerGroup: 1
                }
            ],
            tl: {
                hd: [
                    "440",
                    {
                        slidesPerView: 1.6,
                        spaceBetween: 22,
                        slidesPerGroup: 1
                    }
                ],
                tl: {
                    hd: [
                        "480",
                        {
                            slidesPerView: 1.2,
                            spaceBetween: 22,
                            slidesPerGroup: 1
                        }
                    ],
                    tl: {
                        hd: [
                            "520",
                            {
                                slidesPerView: 1.8,
                                spaceBetween: 22,
                                slidesPerGroup: 1
                            }
                        ],
                        tl: {
                            hd: [
                                "580",
                                {
                                    slidesPerView: 1.8,
                                    spaceBetween: 22,
                                    slidesPerGroup: 1
                                }
                            ],
                            tl: {
                                hd: [
                                    "740",
                                    {
                                        slidesPerView: 2.4,
                                        spaceBetween: 22,
                                        slidesPerGroup: 1
                                    }
                                ],
                                tl: {
                                    hd: [
                                        "780",
                                        {
                                            slidesPerView: 2.8,
                                            spaceBetween: 22,
                                            slidesPerGroup: 1
                                        }
                                    ],
                                    tl: {
                                        hd: [
                                            "820",
                                            {
                                                slidesPerView: 2.4,
                                                spaceBetween: 22,
                                                slidesPerGroup: 1
                                            }
                                        ],
                                        tl: {
                                            hd: [
                                                "1000",
                                                {
                                                    slidesPerView: 4.0,
                                                    spaceBetween: 22,
                                                    slidesPerGroup: 1
                                                }
                                            ],
                                            tl: /* [] */ 0
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
});
var grayBgColor = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* position */.FKU("absolute"),
    tl: {
        hd: BsCss_bs/* top */.wey(BsCss_bs/* pct */.hdZ(55.0)),
        tl: {
            hd: BsCss_bs/* bottom */.IaC(BsCss_bs.px(0)),
            tl: {
                hd: BsCss_bs/* right */.F2z(BsCss_bs.px(0)),
                tl: {
                    hd: BsCss_bs/* left */.t$v(BsCss_bs.px(0)),
                    tl: {
                        hd: BsCss_bs/* backgroundColor */.Czw(Theme_bs/* Color.paleGrey */.Il.paleGrey),
                        tl: /* [] */ 0
                    }
                }
            }
        }
    }
});
var wrapper = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* maxWidth */.kkr(BsCss_bs.px(1450)),
    tl: {
        hd: BsCss_bs/* marginLeft */.oIA(BsCss_bs.px(20)),
        tl: {
            hd: BsCss_bs/* media */.BC2("(min-width: 768px) and (max-width: 1279px)", {
                hd: BsCss_bs/* marginLeft */.oIA(BsCss_bs.px(30)),
                tl: /* [] */ 0
            }),
            tl: {
                hd: BsCss_bs/* media */.BC2("(min-width: 1280px) and (max-width: 1449px)", {
                    hd: BsCss_bs/* marginLeft */.oIA(BsCss_bs.px(30)),
                    tl: {
                        hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(50)),
                        tl: /* [] */ 0
                    }
                }),
                tl: {
                    hd: BsCss_bs/* media */.BC2("(min-width: 1450px)", {
                        hd: BsCss_bs/* marginLeft */.oIA("auto"),
                        tl: {
                            hd: BsCss_bs/* marginRight */.wzR("auto"),
                            tl: {
                                hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(50)),
                                tl: /* [] */ 0
                            }
                        }
                    }),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var AppsReviewSection_bs_container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* backgroundImage */.NxW({
        NAME: "url",
        VAL: "/images/downloadApps/quote_bg.svg"
    }),
    tl: {
        hd: BsCss_bs/* backgroundRepeat */.FDc("noRepeat"),
        tl: {
            hd: BsCss_bs/* backgroundSize */.G4q("auto"),
            tl: {
                hd: BsCss_bs/* position */.FKU("relative"),
                tl: {
                    hd: BsCss_bs/* minWidth */.ihZ(BsCss_bs.px(288)),
                    tl: {
                        hd: BsCss_bs/* minHeight */.jw4(BsCss_bs.px(298)),
                        tl: {
                            hd: BsCss_bs/* borderRadius */.E0l(BsCss_bs.px(8)),
                            tl: {
                                hd: BsCss_bs/* boxShadow */.Wnp(Css_Legacy_Core_bs/* Shadow.box */.jXB.box(BsCss_bs.px(4), BsCss_bs.px(4), BsCss_bs.px(25), undefined, undefined, BsCss_bs/* rgba */.m4f(68, 68, 68, BsCss_bs/* pct */.hdZ(15.0)))),
                                tl: {
                                    hd: BsCss_bs/* backgroundColor */.Czw(Theme_bs/* Color.white */.Il.white),
                                    tl: {
                                        hd: BsCss_bs/* padding */.o3D(BsCss_bs.px(20)),
                                        tl: /* [] */ 0
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
});
var swiperContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(27)),
    tl: {
        hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs.px(27)),
        tl: {
            hd: BsCss_bs/* paddingLeft */.rv2(BsCss_bs.px(10)),
            tl: /* [] */ 0
        }
    }
});
var AppsReviewSection_bs_headerText = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* position */.FKU("relative"),
    tl: {
        hd: BsCss_bs/* color */.$_Y(BsCss_bs/* hex */.$v1("444")),
        tl: {
            hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(32)),
            tl: {
                hd: BsCss_bs/* fontWeight */.Ue2({
                    NAME: "num",
                    VAL: 600
                }),
                tl: {
                    hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(40)),
                    tl: {
                        hd: BsCss_bs/* media */.BC2("(min-width: 768px) and (max-width: 1023px)", {
                            hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs.px(16)),
                            tl: /* [] */ 0
                        }),
                        tl: /* [] */ 0
                    }
                }
            }
        }
    }
});
var AppsReviewSection_bs_Styles = {
    grayBgColor: grayBgColor,
    wrapper: wrapper,
    container: AppsReviewSection_bs_container,
    swiperContainer: swiperContainer,
    headerText: AppsReviewSection_bs_headerText
};
function AppsReviewSection(props) {
    return jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsx("div", {
                className: grayBgColor
            }),
            jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsx("h1", {
                        children: util_bs/* ReactStuff.s */.p_.s("What our customers are saying"),
                        className: AppsReviewSection_bs_headerText
                    }),
                    jsx_runtime.jsxs(swiper_react/* Swiper */.tq, {
                        breakpoints: caml_option/* some */.G(swiperBreakpoints),
                        children: [
                            jsx_runtime.jsx(swiper_react/* SwiperSlide */.o5, {
                                className: AppsReviewSection_bs_container,
                                children: jsx_runtime.jsx(ReviewCard_bs_make, {
                                    bodyText: "Many of my family members live interstate and I use Prezzee to send gift vouchers. It's really cool the way you can upload a video and schedule the time for delivery of the voucher to the recipient.",
                                    titleText: "Great app for sending gift cards"
                                })
                            }),
                            jsx_runtime.jsx(swiper_react/* SwiperSlide */.o5, {
                                className: AppsReviewSection_bs_container,
                                children: jsx_runtime.jsx(ReviewCard_bs_make, {
                                    bodyText: "The app is super easy - you can swap out Prezzee gift vouchers for store gift cards with lots of choice. As a recipient, you can easily navigate, choose what vouchers you want at a click, even at the store counter when paying.",
                                    titleText: "Without a doubt the easiest way to send a gift card"
                                })
                            }),
                            jsx_runtime.jsx(swiper_react/* SwiperSlide */.o5, {
                                className: AppsReviewSection_bs_container,
                                children: jsx_runtime.jsx(ReviewCard_bs_make, {
                                    bodyText: "Huge variety of gift cards and so easy to use and I love how you can schedule a date for the card to be delivered. I will definitely be using Prezzee again",
                                    titleText: "So user friendly"
                                })
                            }),
                            jsx_runtime.jsx(swiper_react/* SwiperSlide */.o5, {
                                className: AppsReviewSection_bs_container,
                                children: jsx_runtime.jsx(ReviewCard_bs_make, {
                                    bodyText: "Really like being able to sms a birthday video as well as the $ in gift cards. It ensures that the birthday person thinks about what they really want and buys it.",
                                    titleText: "Quick and easy present giving!"
                                })
                            }),
                            jsx_runtime.jsx(swiper_react/* SwiperSlide */.o5, {
                                children: util_bs/* ReactStuff.s */.p_.s("")
                            })
                        ],
                        className: swiperContainer,
                        grabCursor: true,
                        slidesPerView: 10
                    })
                ],
                className: wrapper
            })
        ],
        className: "relative"
    });
}
var AppsReviewSection_bs_make = AppsReviewSection;
var AppsReviewSection_bs_$$default = (/* unused pure expression or super */ null && (AppsReviewSection));
 /* swiperBreakpoints Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/apps/FeatureItem.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE






var FeatureItem_bs_container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("flex"),
    tl: {
        hd: BsCss_bs/* alignItems */.cq$("center"),
        tl: {
            hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(28)),
            tl: /* [] */ 0
        }
    }
});
var FeatureItem_bs_img = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs.px(24)),
    tl: {
        hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(24)),
        tl: {
            hd: BsCss_bs/* marginRight */.wzR(BsCss_bs.px(20)),
            tl: /* [] */ 0
        }
    }
});
var FeatureItem_bs_bodyText = curry._1(BsCss_bs/* style */.oBv, {
    hd: Theme_bs/* Typography.defaultFonts */.ZT.defaultFonts,
    tl: {
        hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(16)),
        tl: {
            hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(24)),
            tl: {
                hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.darkGrey */.Il.darkGrey),
                tl: {
                    hd: BsCss_bs/* fontWeight */.Ue2("normal"),
                    tl: {
                        hd: BsCss_bs/* fontStyle */.p_N("normal"),
                        tl: {
                            hd: BsCss_bs/* media */.BC2("(min-width: 768px) and (max-width: 1023px)", {
                                hd: BsCss_bs/* width */.bf$(BsCss_bs.px(215)),
                                tl: /* [] */ 0
                            }),
                            tl: {
                                hd: BsCss_bs/* media */.BC2("(min-width: 1024px)", {
                                    hd: BsCss_bs/* width */.bf$(BsCss_bs.px(215)),
                                    tl: /* [] */ 0
                                }),
                                tl: /* [] */ 0
                            }
                        }
                    }
                }
            }
        }
    }
});
var FeatureItem_bs_Styles = {
    container: FeatureItem_bs_container,
    img: FeatureItem_bs_img,
    bodyText: FeatureItem_bs_bodyText
};
function FeatureItem(props) {
    return jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                src: props.iconSrc,
                alt: props.iconDescription,
                width: 24,
                height: 24,
                className: FeatureItem_bs_img
            }),
            jsx_runtime.jsx("h4", {
                children: util_bs/* ReactStuff.s */.p_.s(props.bodyText),
                className: FeatureItem_bs_bodyText
            })
        ],
        className: FeatureItem_bs_container
    });
}
var FeatureItem_bs_make = FeatureItem;
 /* container Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/apps/AppsFeatureSection.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE









var AppsFeatureSection_bs_container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* backgroundColor */.Czw(Theme_bs/* Color.paleGrey */.Il.paleGrey),
    tl: {
        hd: BsCss_bs/* media */.BC2("(min-width: 1024px)", {
            hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(30)),
            tl: {
                hd: BsCss_bs/* paddingLeft */.rv2(BsCss_bs.px(30)),
                tl: /* [] */ 0
            }
        }),
        tl: /* [] */ 0
    }
});
var AppsFeatureSection_bs_leftContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* media */.BC2("(min-width: 1414px)", {
        hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(50)),
        tl: {
            hd: BsCss_bs/* paddingLeft */.rv2(BsCss_bs.px(80)),
            tl: /* [] */ 0
        }
    }),
    tl: /* [] */ 0
});
var leftInnerContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* marginLeft */.oIA(BsCss_bs.px(20)),
    tl: {
        hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(20)),
        tl: {
            hd: BsCss_bs/* media */.BC2("(min-width: 768px) and (max-width: 1023px)", {
                hd: BsCss_bs/* marginLeft */.oIA("auto"),
                tl: {
                    hd: BsCss_bs/* display */.jfB("flex"),
                    tl: {
                        hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(90)),
                        tl: {
                            hd: BsCss_bs/* marginRight */.wzR("auto"),
                            tl: {
                                hd: BsCss_bs/* justifyContent */.KlP("spaceAround"),
                                tl: {
                                    hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(10)),
                                    tl: /* [] */ 0
                                }
                            }
                        }
                    }
                }
            }),
            tl: {
                hd: BsCss_bs/* media */.BC2("(min-width: 1024px) and (max-width: 1413px)", {
                    hd: BsCss_bs/* display */.jfB("flex"),
                    tl: {
                        hd: BsCss_bs/* justifyContent */.KlP("spaceBetween"),
                        tl: {
                            hd: BsCss_bs/* marginLeft */.oIA("zero"),
                            tl: /* [] */ 0
                        }
                    }
                }),
                tl: {
                    hd: BsCss_bs/* media */.BC2("(min-width: 1414px)", {
                        hd: BsCss_bs/* display */.jfB("flex"),
                        tl: {
                            hd: BsCss_bs/* justifyContent */.KlP("spaceBetween"),
                            tl: {
                                hd: BsCss_bs/* marginLeft */.oIA("zero"),
                                tl: {
                                    hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(70)),
                                    tl: /* [] */ 0
                                }
                            }
                        }
                    }),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var AppsFeatureSection_bs_appsInnerDiv = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("flex"),
    tl: {
        hd: BsCss_bs/* justifyContent */.KlP("center"),
        tl: {
            hd: BsCss_bs/* media */.BC2("(min-width: 1024px)", {
                hd: BsCss_bs/* justifyContent */.KlP("flexStart"),
                tl: /* [] */ 0
            }),
            tl: /* [] */ 0
        }
    }
});
var AppsFeatureSection_bs_appsLogo = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs.px(158)),
    tl: {
        hd: BsCss_bs/* marginRight */.wzR(BsCss_bs.px(20)),
        tl: /* [] */ 0
    }
});
var AppsFeatureSection_bs_subTitleText = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* position */.FKU("relative"),
    tl: {
        hd: BsCss_bs/* color */.$_Y(BsCss_bs/* hex */.$v1("000")),
        tl: {
            hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(32)),
            tl: {
                hd: BsCss_bs/* fontWeight */.Ue2({
                    NAME: "num",
                    VAL: 600
                }),
                tl: {
                    hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(40)),
                    tl: {
                        hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs.px(24)),
                        tl: {
                            hd: BsCss_bs/* textAlign */.ydu("center"),
                            tl: {
                                hd: BsCss_bs/* media */.BC2("(min-width: 1024px)", {
                                    hd: BsCss_bs/* textAlign */.ydu("left"),
                                    tl: /* [] */ 0
                                }),
                                tl: /* [] */ 0
                            }
                        }
                    }
                }
            }
        }
    }
});
var phoneHand = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(100)),
    tl: {
        hd: BsCss_bs/* media */.BC2("(min-width: 768px) and (max-width: 1023px)", {
            hd: BsCss_bs/* display */.jfB("none"),
            tl: /* [] */ 0
        }),
        tl: {
            hd: BsCss_bs/* media */.BC2("(min-width: 1024px) and (max-width: 1413px)", {
                hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(50)),
                tl: /* [] */ 0
            }),
            tl: {
                hd: BsCss_bs/* media */.BC2("(min-width: 1414px)", {
                    hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(45)),
                    tl: /* [] */ 0
                }),
                tl: /* [] */ 0
            }
        }
    }
});
var phoneHandMd = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("none"),
    tl: {
        hd: BsCss_bs/* media */.BC2("(min-width: 768px) and (max-width: 1023px)", {
            hd: BsCss_bs/* display */.jfB("block"),
            tl: {
                hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(60.0)),
                tl: {
                    hd: BsCss_bs/* overflow */.txR("auto"),
                    tl: /* [] */ 0
                }
            }
        }),
        tl: /* [] */ 0
    }
});
var AppsFeatureSection_bs_bodyText = curry._1(BsCss_bs/* style */.oBv, {
    hd: Theme_bs/* Typography.defaultFonts */.ZT.defaultFonts,
    tl: {
        hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(14)),
        tl: {
            hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(20)),
            tl: {
                hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.midGrey */.Il.midGrey),
                tl: {
                    hd: BsCss_bs/* fontWeight */.Ue2("normal"),
                    tl: {
                        hd: BsCss_bs/* fontStyle */.p_N("normal"),
                        tl: {
                            hd: BsCss_bs/* marginLeft */.oIA(BsCss_bs.px(20)),
                            tl: {
                                hd: BsCss_bs/* marginRight */.wzR(BsCss_bs.px(20)),
                                tl: {
                                    hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(15)),
                                    tl: {
                                        hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs.px(15)),
                                        tl: {
                                            hd: BsCss_bs/* media */.BC2("(min-width: 768px) and (max-width: 1279px)", {
                                                hd: BsCss_bs/* marginLeft */.oIA(BsCss_bs.px(30)),
                                                tl: /* [] */ 0
                                            }),
                                            tl: {
                                                hd: BsCss_bs/* media */.BC2("(min-width: 1280px) and (max-width: 1449px)", {
                                                    hd: BsCss_bs/* marginLeft */.oIA(BsCss_bs.px(60)),
                                                    tl: /* [] */ 0
                                                }),
                                                tl: {
                                                    hd: BsCss_bs/* media */.BC2("(min-width: 1450px)", {
                                                        hd: BsCss_bs/* marginLeft */.oIA(BsCss_bs.px(60)),
                                                        tl: /* [] */ 0
                                                    }),
                                                    tl: /* [] */ 0
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
});
var AppsFeatureSection_bs_Styles = {
    container: AppsFeatureSection_bs_container,
    leftContainer: AppsFeatureSection_bs_leftContainer,
    leftInnerContainer: leftInnerContainer,
    appsInnerDiv: AppsFeatureSection_bs_appsInnerDiv,
    appsLogo: AppsFeatureSection_bs_appsLogo,
    subTitleText: AppsFeatureSection_bs_subTitleText,
    phoneHand: phoneHand,
    phoneHandMd: phoneHandMd,
    bodyText: AppsFeatureSection_bs_bodyText
};
function AppsFeatureSection(props) {
    var match = util_bs/* EnvUtil.currentCountry */.i3.currentCountry;
    var tmp;
    tmp = match.TAG === /* Ok */ 0 && match._0 === 2 ? "/images/downloadApps/downloadTheApp_PhoneHand_us.png" : "/images/downloadApps/downloadTheApp_PhoneHand.png";
    return jsx_runtime.jsxs(jsx_runtime.Fragment, {
        children: [
            jsx_runtime.jsx("div", {
                children: jsx_runtime.jsxs("div", {
                    children: [
                        jsx_runtime.jsxs("div", {
                            children: [
                                jsx_runtime.jsxs("div", {
                                    children: [
                                        jsx_runtime.jsxs("div", {
                                            children: [
                                                jsx_runtime.jsx(FeatureItem_bs_make, {
                                                    bodyText: "Easily buy, send, store and redeem your gift cards",
                                                    iconSrc: "/images/icon_no_fees.svg",
                                                    iconDescription: "icon_no_fees"
                                                }),
                                                jsx_runtime.jsx(FeatureItem_bs_make, {
                                                    bodyText: util_bs/* EnvUtil.countryCode */.i3.countryCode === "US" ? "Send eGift cards with a personalized video message" : "Send eGift cards with a personalised video message",
                                                    iconSrc: "/images/icon_laptop_gift.svg",
                                                    iconDescription: "icon_laptop_gift"
                                                })
                                            ]
                                        }),
                                        jsx_runtime.jsxs("div", {
                                            children: [
                                                jsx_runtime.jsx(FeatureItem_bs_make, {
                                                    bodyText: "In-app support via email and phone",
                                                    iconSrc: "/images/icon_customer_service.svg",
                                                    iconDescription: "icon_customer_service"
                                                }),
                                                jsx_runtime.jsx(FeatureItem_bs_make, {
                                                    bodyText: "Check your gift card balances in real time*",
                                                    iconSrc: "/images/icon_store_in_wallet.svg",
                                                    iconDescription: "icon_store_in_wallet"
                                                })
                                            ]
                                        })
                                    ],
                                    className: leftInnerContainer
                                }),
                                jsx_runtime.jsxs("div", {
                                    children: [
                                        jsx_runtime.jsxs("div", {
                                            children: [
                                                jsx_runtime.jsx("h2", {
                                                    children: util_bs/* ReactStuff.s */.p_.s("Get it now for iOS and Android"),
                                                    className: AppsFeatureSection_bs_subTitleText
                                                }),
                                                jsx_runtime.jsxs("div", {
                                                    children: [
                                                        jsx_runtime.jsx(DownloadAppleApp_bs/* make */.S, {
                                                            className: AppsFeatureSection_bs_appsLogo
                                                        }),
                                                        jsx_runtime.jsx(DownloadGoogleApp_bs/* make */.S, {
                                                            className: AppsFeatureSection_bs_appsLogo
                                                        })
                                                    ],
                                                    className: AppsFeatureSection_bs_appsInnerDiv
                                                })
                                            ]
                                        }),
                                        jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                                            src: tmp,
                                            alt: "downloadTheApp_PhoneHand",
                                            width: 844,
                                            height: 621,
                                            className: phoneHandMd
                                        })
                                    ],
                                    className: "md:flex items-center"
                                })
                            ],
                            className: AppsFeatureSection_bs_leftContainer
                        }),
                        jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                            src: tmp,
                            alt: "downloadTheApp_PhoneHand",
                            width: 844,
                            height: 621,
                            className: phoneHand
                        })
                    ],
                    className: "lg:flex justify-between items-center"
                }),
                className: AppsFeatureSection_bs_container
            }),
            jsx_runtime.jsx("p", {
                children: util_bs/* ReactStuff.s */.p_.s("*Always available for Prezzee Smart eGift Cards. Live balances for retailers are dependent on the individual retailer  providing that information"),
                className: AppsFeatureSection_bs_bodyText
            })
        ]
    });
}
var AppsFeatureSection_bs_make = AppsFeatureSection;
var AppsFeatureSection_bs_$$default = (/* unused pure expression or super */ null && (AppsFeatureSection));
 /* container Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/apps/DownloadApps.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE







function DownloadApps(props) {
    return jsx_runtime.jsxs(jsx_runtime.Fragment, {
        children: [
            jsx_runtime.jsx(make, {}),
            jsx_runtime.jsx(AppsReviewSection_bs_make, {}),
            jsx_runtime.jsx(AppsFeatureSection_bs_make, {})
        ]
    });
}
function getServerSideProps(param) {
    if (Belt_Option.isNone(Js_dict.get(param.query, "preview"))) {
        param.res.setHeader("Cache-Control", Constants.ssr_page_cache);
    }
    return {
        props: {}
    };
}
var DownloadApps_bs_make = DownloadApps;
var DownloadApps_bs_$$default = (/* unused pure expression or super */ null && (DownloadApps));
 /* AppsHeaderSection Not a pure module */ 

;// CONCATENATED MODULE: ./src/pages/app.js
__webpack_require__(14473);

var __N_SSP = true;



/***/ }),

/***/ 75897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Link */
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99813);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72491);
/* harmony import */ var _StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30369);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE






function DownloadAppleApp(props) {
    var baseHref = "https://itunes.apple.com/au/app/prezzee/id1047060902";
    var country = _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.currentCountry */ .i3.currentCountry;
    var href;
    href = country.TAG === /* Ok */ 0 ? baseHref.replace("au", _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_1__/* .lowercase_ascii */ .uq(_common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.getCountryCode */ .i3.getCountryCode(country._0))) : baseHref;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        prefetch: false,
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("a", {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
                src: "/images/badge_apple_store.svg",
                alt: "Download on the App Store Logo",
                width: 125,
                height: 37,
                className: "w-full ml-1"
            }),
            className: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .getWithDefault */ .tj(props.className, "")
        })
    });
}
var Link$1;
var make = DownloadAppleApp;
 /* Util Not a pure module */ 


/***/ }),

/***/ 59195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Link */
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99813);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72491);
/* harmony import */ var _StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30369);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE






function DownloadGoogleApp(props) {
    var baseHref = "https://play.google.com/store/apps/details?id=com.prezzee.prezzee";
    var country = _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.currentCountry */ .i3.currentCountry;
    var href;
    href = country.TAG === /* Ok */ 0 ? baseHref + ("&gl=" + _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_1__/* .lowercase_ascii */ .uq(_common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.getCountryCode */ .i3.getCountryCode(country._0))) : baseHref;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        prefetch: false,
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("a", {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
                src: "/images/badge_play_store.svg",
                alt: "Download on the App Store Logo",
                width: 125,
                height: 37,
                className: "w-full mr-1"
            }),
            className: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .getWithDefault */ .tj(props.className, "")
        })
    });
}
var Link$1;
var make = DownloadGoogleApp;
 /* Util Not a pure module */ 


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8929,9774,2888,179], function() { return __webpack_exec__(90401); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);